import api, { API_URL } from '../utils/api';

async function downloadCsv(endpoint, params) {
  const token = api.getToken();
  const query = new URLSearchParams(Object.entries(params || {}).filter(([, v]) => v !== '' && v != null));
  const response = await fetch(`${API_URL}${endpoint}?${query.toString()}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    let detail = 'Export failed';
    try { detail = (await response.json())?.detail || detail; } catch (_) { /* not JSON */ }
    throw new Error(detail);
  }
  const blob = await response.blob();
  const disposition = response.headers.get('Content-Disposition') || '';
  const match = disposition.match(/filename=([^;]+)/);
  const filename = match ? match[1].trim() : 'report.csv';
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

const reportsAnalyticsService = {
  attendance: (params) => api.get('/api/reports/attendance', { params }),
  exportAttendance: (params) => downloadCsv('/api/reports/attendance/export', params),

  feeCollection: (params) => api.get('/api/reports/fee-collection', { params }),
  exportFeeCollection: (params) => downloadCsv('/api/reports/fee-collection/export', params),

  academicPerformance: (params) => api.get('/api/reports/academic-performance', { params }),
  exportAcademicPerformance: (params) => downloadCsv('/api/reports/academic-performance/export', params),

  enrollment: (params) => api.get('/api/reports/enrollment', { params }),
  exportEnrollment: (params) => downloadCsv('/api/reports/enrollment/export', params),
};

export default reportsAnalyticsService;
